import * as React from 'react'

export type BadgeTone = 'brand' | 'neutral'

export interface BadgeProps {
  children: React.ReactNode;
  /** Colour treatment. `brand` for emphasis (e.g. "NEW"), `neutral` for metadata (e.g. "4K"). */
  tone?: BadgeTone;
  className?: string;
}

/** A small pill label for media metadata — "NEW", "4K", "HDR", etc. */
export function Badge ({ children, tone = 'brand', className }: BadgeProps) {
  const classes = ['mlsg-badge', `mlsg-badge--${tone}`, className].filter(Boolean).join(' ')
  return <span className={classes}>{children}</span>
}
